export class assingResponsibleCustomer {
    responsibleRequestTypeId: string;
    customerId: string;
    mainResponsible: boolean;
    active: boolean;
}

